export default {
  appvue: null,
  $store: null,
  stakeinfovue: null,

  topnavvue: {},
  topnavAccountBtnVue: {},

  // 全局lava价格
  lava_price: null,
}